'use client'
import Modal from '@/components/Modal';
import { getImageUrl, sendRequest } from '@/lib/api-service';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';

export default function Page() {
	const [selectedImage, setSelectedImage] = useState<string | null>(null);
	const [approach, setApproach] = useState<boolean>(false);
	const [history, setHistory] = useState<string>('');
	const [awards, setAwards] = useState<string>('');
	const [terms, setTerms] = useState<string>('');
	const [awardImages, setAwardImages] = useState<string[]>([]);
	const [historyImages, setHistoryImages] = useState<string[]>([]);
	const [headerImage, setHeaderImage] = useState<string|null>(null);


	useEffect(() => {
		const fetchTexts = async () => {
			const response = await sendRequest('POST', '/dynamic-texts/', {codes:["history", "awards", "terms"]}, true);
			if (response && typeof response === 'object' && !Array.isArray(response)) {
				if ('history' in response) setHistory(response.history);
				if ('awards' in response) setAwards(response.awards);
				if ('terms' in response) setTerms(response.terms);
			}
		};
		const fetchAwardImages = async () => {
			const response = await sendRequest('GET', '/award-images/', {}, true);
			if (response && Array.isArray(response)) {
				setAwardImages(response.map((item: { image: string }) => item.image).filter(Boolean));
			}
		};

		const fetchHistoryImages = async () => {
			const response = await sendRequest('GET', '/history-images/', {}, true);
			if (response && Array.isArray(response)) {
				setHistoryImages(response.map((item: { image: string }) => item.image).filter(Boolean));
			}
		};

		const fetchDynamicImages = async () => {
			const response = await sendRequest('POST', '/dynamic-images/', {codes:["who_we_are"]}, true);
			if (response && Array.isArray(response)) {
				const whoWeAreImg = response.find((img: { code: string }) => img.code === "who_we_are");
				if (whoWeAreImg && whoWeAreImg.image) setHeaderImage(whoWeAreImg.image);
			}
		};
		fetchDynamicImages();
		fetchHistoryImages();
		fetchAwardImages();
		fetchTexts();
	}, []);


	return (
		<>
			<Modal
				isOpen={approach}
				onClose={() => setApproach(false)}
			>
				<span dangerouslySetInnerHTML={{ __html: terms }} />
			</Modal>

		<div className="bg-white max-w-[1920px] mx-auto">
			{selectedImage && (
				<div
					className='fixed inset-0 bg-black/80 flex items-center justify-center z-50'
					onClick={() => setSelectedImage(null)}
				>
					<div
						className='relative max-w-[90vw] max-h-[90vh] w-auto h-auto'
						onClick={(e) => e.stopPropagation()}
					>
						<button
							onClick={() => setSelectedImage(null)}
							className='absolute top-2 right-2 text-white z-10 hover:text-gray-300'
						>
							<FaTimes size={28} />
						</button>
						<img
							src={selectedImage}
							alt='Enlarged image'
							width={1600}
							height={1200}
							className='max-w-full max-h-[90vh] w-auto h-auto rounded-lg object-contain'
						/>
					</div>
				</div>
			)}

			<div className="relative w-full h-[40vh]">
				{headerImage && (
					<Image
						src={getImageUrl(headerImage)}
						alt="Who we are"
						fill
						className="object-cover"
					/>
				)}
				<div className="absolute inset-0 bg-black/10 flex items-center justify-center">
					<h1 className="text-4xl md:text-6xl font-bold mb-4 drop-shadow-md header text-transparent bg-clip-text bg-gradient-to-b from-fire-500 to-fire-900 uppercase">
						Бид хэн бэ?
					</h1>
				</div>
				<div
					className="w-full h-[20vh] opacity-25 bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/1.svg')" }}
				/>
				<div
					className="w-full h-[20vh] opacity-25 bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/2.svg')" }}
				/>
				<div
					className="w-full h-[20vh] opacity-25  bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/3.svg')" }}
				/>
				<div
					className="w-full h-[30vh]  bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/low.svg')" }}
				/>
			</div>

			<div className="grid grid-cols-10 max-w-6xl px-5 mx-auto py-20 bg-white gap-y-10 gap-x-4">
				<div className='col-span-10 space-y-4'>
					<div className='text-mountain-900 uppercase font-semibold text-2xl'>Үүсэл түүх</div>
					<div className='text-lg'>
						<span dangerouslySetInnerHTML={{ __html: history }} />
					</div>
					<div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4'>
						{historyImages.map((src, idx) => (
							<button key={idx} onClick={() => setSelectedImage(getImageUrl(src))}>
								<img
									src={getImageUrl(src)}
									alt={`Image ${idx + 6}`}
									width={500}
									height={500}
									className='w-full h-auto rounded-lg object-cover transition duration-200 hover:scale-105'
								/>
							</button>
						))}
					</div>
				</div>

				<div className='col-span-10 space-y-4'>
					<div className='text-mountain-900 uppercase font-semibold text-2xl'>Зуслангаа алдаршуулья:</div>
					<div className='text-lg'>
						<span dangerouslySetInnerHTML={{ __html: awards }} />
					</div>
					<div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4'>
						{awardImages.map((src, idx) => (
							<button key={idx} onClick={() => setSelectedImage(getImageUrl(src))}>
								<img
									src={getImageUrl(src)}
									alt={`Image ${idx + 6}`}
									width={500}
									height={500}
									className='w-full h-auto rounded-lg object-cover transition duration-200 hover:scale-105'
								/>
							</button>
						))}
					</div>
				</div>

				<div className='col-span-10 space-y-4'>
					<div className='text-mountain-900 uppercase font-semibold text-2xl'>Хүүхдийн аюулгүй байдал: </div>
					<div className='flex items-center'>
						<span className='text-mountain-600 text-2xl mr-2 p-1 rounded-full border-2'>
							<FaCheck size={16} />
						</span>
						<span>
							Хүүхэд хамгааллын <span onClick={() => setApproach(true)} className='underline text-blue-600 cursor-pointer ms-1 inline-block'>бодлого</span>той /Бүх багш нар маань хүүхэдтэй ажиллах мэргэжлийн багш нар байдаг/
						</span>
					</div>
					<div className='flex items-center'>
						<span className='text-mountain-600 text-2xl mr-2 p-1 rounded-full border-2'>
							<FaCheck size={16} />
						</span>
						24 цагийн бүрэн камерын хяналттай
					</div>
					<div className='flex items-center'>
						<span className='text-mountain-600 text-2xl mr-2 p-1 rounded-full border-2'>
							<FaCheck size={16} />
						</span>
						Харуул хамгаалалт
					</div>
					<div className='flex items-center'>
						<span className='text-mountain-600 text-2xl mr-2 p-1 rounded-full border-2'>
							<FaCheck size={16} />
						</span>
						Амрагч хүүхдүүдийн даатгал
					</div>
					<div className='flex items-center'>
						<span className='text-mountain-600 text-2xl mr-2 p-1 rounded-full border-2'>
							<FaCheck size={16} />
						</span>
						Хоол хүнсний эрүүл ахуйн шинжилгээнд байнга хамрагддаг /Олон жилийн туршлагатай мэргэжлийн тогооч нар/
					</div>
					<div className='flex items-center'>
						<span className='text-mountain-600 text-2xl mr-2 p-1 rounded-full border-2'>
							<FaCheck size={16} />
						</span>
						Ариутгал, халдваргүйжүүлэлтийг тогтмол хийдэг
					</div>
				</div>
			</div>
		</div>
		</>

	);
}
